// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: atdcK1hSZxqWg32TQQ3iWK
// Component: u-d47oXKac
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PHeader from "../../PHeader"; // plasmic-import: PGN87NpT68/component
import Membership from "../../Membership"; // plasmic-import: zbsa8DcniG/component
import SgsButton from "../../SgsButton"; // plasmic-import: IttYPCKbiznL/component
import { useScreenVariants as useScreenVariantscmLbcqStcJj } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: CMLbcqStcJJ/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_blank_website_mobile_first.module.css"; // plasmic-import: atdcK1hSZxqWg32TQQ3iWK/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: u-d47oXKac/css
import Icon5Icon from "../sgs_golf/icons/PlasmicIcon__Icon5"; // plasmic-import: GUtmGiuNpjv-/icon

createPlasmicElementProxy;

export const PlasmicHomepage__VariantProps = new Array("viewState");

export const PlasmicHomepage__ArgProps = new Array("noAuthorization");

const $$ = {};

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          noAuthorization: false
        },
        props.args
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "variable",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "viewState",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.viewState
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantscmLbcqStcJj()
  });
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          sty.root,
          {
            [sty.rootviewState_admin]: hasVariant($state, "viewState", "admin"),
            [sty.rootviewState_courses]: hasVariant(
              $state,
              "viewState",
              "courses"
            ),
            [sty.rootviewState_history]: hasVariant(
              $state,
              "viewState",
              "history"
            ),
            [sty.rootviewState_login]: hasVariant($state, "viewState", "login"),
            [sty.rootviewState_magicLink]: hasVariant(
              $state,
              "viewState",
              "magicLink"
            ),
            [sty.rootviewState_membership]: hasVariant(
              $state,
              "viewState",
              "membership"
            ),
            [sty.rootviewState_resetPassword]: hasVariant(
              $state,
              "viewState",
              "resetPassword"
            )
          }
        )}
      >
        <PHeader
          data-plasmic-name={"pHeader"}
          data-plasmic-override={overrides.pHeader}
          className={classNames("__wab_instance", sty.pHeader, {
            [sty.pHeaderviewState_admin]: hasVariant(
              $state,
              "viewState",
              "admin"
            ),
            [sty.pHeaderviewState_courses]: hasVariant(
              $state,
              "viewState",
              "courses"
            ),
            [sty.pHeaderviewState_history]: hasVariant(
              $state,
              "viewState",
              "history"
            ),
            [sty.pHeaderviewState_login]: hasVariant(
              $state,
              "viewState",
              "login"
            ),
            [sty.pHeaderviewState_magicLink]: hasVariant(
              $state,
              "viewState",
              "magicLink"
            ),
            [sty.pHeaderviewState_membership]: hasVariant(
              $state,
              "viewState",
              "membership"
            ),
            [sty.pHeaderviewState_resetPassword]: hasVariant(
              $state,
              "viewState",
              "resetPassword"
            )
          })}
        />

        <section
          data-plasmic-name={"tabs"}
          data-plasmic-override={overrides.tabs}
          className={classNames(projectcss.all, sty.tabs, {
            [sty.tabsviewState_history]: hasVariant(
              $state,
              "viewState",
              "history"
            )
          })}
        />

        <section
          data-plasmic-name={"courses"}
          data-plasmic-override={overrides.courses}
          className={classNames(projectcss.all, sty.courses, {
            [sty.coursesviewState_admin]: hasVariant(
              $state,
              "viewState",
              "admin"
            ),
            [sty.coursesviewState_courses]: hasVariant(
              $state,
              "viewState",
              "courses"
            ),
            [sty.coursesviewState_history]: hasVariant(
              $state,
              "viewState",
              "history"
            ),
            [sty.coursesviewState_login]: hasVariant(
              $state,
              "viewState",
              "login"
            ),
            [sty.coursesviewState_magicLink]: hasVariant(
              $state,
              "viewState",
              "magicLink"
            ),
            [sty.coursesviewState_membership]: hasVariant(
              $state,
              "viewState",
              "membership"
            ),
            [sty.coursesviewState_resetPassword]: hasVariant(
              $state,
              "viewState",
              "resetPassword"
            )
          })}
        />

        <section
          data-plasmic-name={"membershipWrapper"}
          data-plasmic-override={overrides.membershipWrapper}
          className={classNames(projectcss.all, sty.membershipWrapper, {
            [sty.membershipWrapperviewState_history]: hasVariant(
              $state,
              "viewState",
              "history"
            ),
            [sty.membershipWrapperviewState_membership]: hasVariant(
              $state,
              "viewState",
              "membership"
            )
          })}
        >
          <Membership
            data-plasmic-name={"membership"}
            data-plasmic-override={overrides.membership}
            className={classNames("__wab_instance", sty.membership, {
              [sty.membershipviewState_membership]: hasVariant(
                $state,
                "viewState",
                "membership"
              )
            })}
          />
        </section>
        <div
          className={classNames(projectcss.all, sty.freeBox__vKRoE, {
            [sty.freeBoxviewState_admin__vKRoElUJzW]: hasVariant(
              $state,
              "viewState",
              "admin"
            ),
            [sty.freeBoxviewState_history__vKRoEo2DSo]: hasVariant(
              $state,
              "viewState",
              "history"
            ),
            [sty.freeBoxviewState_login__vKRoEiWmQj]: hasVariant(
              $state,
              "viewState",
              "login"
            ),
            [sty.freeBoxviewState_magicLink__vKRoECw81W]: hasVariant(
              $state,
              "viewState",
              "magicLink"
            ),
            [sty.freeBoxviewState_resetPassword__vKRoEKeHBe]: hasVariant(
              $state,
              "viewState",
              "resetPassword"
            )
          })}
        >
          <div
            data-plasmic-name={"login"}
            data-plasmic-override={overrides.login}
            className={classNames(projectcss.all, sty.login, {
              [sty.loginviewState_admin]: hasVariant(
                $state,
                "viewState",
                "admin"
              ),
              [sty.loginviewState_login]: hasVariant(
                $state,
                "viewState",
                "login"
              ),
              [sty.loginviewState_magicLink]: hasVariant(
                $state,
                "viewState",
                "magicLink"
              ),
              [sty.loginviewState_resetPassword]: hasVariant(
                $state,
                "viewState",
                "resetPassword"
              )
            })}
          />

          <div
            data-plasmic-name={"admin"}
            data-plasmic-override={overrides.admin}
            className={classNames(projectcss.all, sty.admin, {
              [sty.adminviewState_admin]: hasVariant(
                $state,
                "viewState",
                "admin"
              ),
              [sty.adminviewState_login]: hasVariant(
                $state,
                "viewState",
                "login"
              ),
              [sty.adminviewState_magicLink]: hasVariant(
                $state,
                "viewState",
                "magicLink"
              ),
              [sty.adminviewState_resetPassword]: hasVariant(
                $state,
                "viewState",
                "resetPassword"
              )
            })}
          />

          <div
            data-plasmic-name={"resetPassword"}
            data-plasmic-override={overrides.resetPassword}
            className={classNames(projectcss.all, sty.resetPassword, {
              [sty.resetPasswordviewState_admin]: hasVariant(
                $state,
                "viewState",
                "admin"
              ),
              [sty.resetPasswordviewState_history]: hasVariant(
                $state,
                "viewState",
                "history"
              ),
              [sty.resetPasswordviewState_login]: hasVariant(
                $state,
                "viewState",
                "login"
              ),
              [sty.resetPasswordviewState_magicLink]: hasVariant(
                $state,
                "viewState",
                "magicLink"
              ),
              [sty.resetPasswordviewState_resetPassword]: hasVariant(
                $state,
                "viewState",
                "resetPassword"
              )
            })}
          />

          <div
            data-plasmic-name={"magicLink"}
            data-plasmic-override={overrides.magicLink}
            className={classNames(projectcss.all, sty.magicLink, {
              [sty.magicLinkviewState_admin]: hasVariant(
                $state,
                "viewState",
                "admin"
              ),
              [sty.magicLinkviewState_history]: hasVariant(
                $state,
                "viewState",
                "history"
              ),
              [sty.magicLinkviewState_login]: hasVariant(
                $state,
                "viewState",
                "login"
              ),
              [sty.magicLinkviewState_magicLink]: hasVariant(
                $state,
                "viewState",
                "magicLink"
              ),
              [sty.magicLinkviewState_resetPassword]: hasVariant(
                $state,
                "viewState",
                "resetPassword"
              )
            })}
          />
        </div>
        {(
          hasVariant(globalVariants, "screen", "desktopOnly")
            ? $props.noAuthorization
            : (() => {
                try {
                  return $props.noAuthorization;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return true;
                  }
                  throw e;
                }
              })()
        ) ? (
          <div className={classNames(projectcss.all, sty.freeBox__dlTl8)}>
            <div className={classNames(projectcss.all, sty.freeBox__lcxwL)}>
              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text,
                  {
                    [sty.textviewState_courses]: hasVariant(
                      $state,
                      "viewState",
                      "courses"
                    )
                  }
                )}
              >
                {
                  "Et ole kirjautunut sis\u00e4\u00e4n ja voit vain katsella SGS:n senioripelioikeuksia tekem\u00e4tt\u00e4 varauksia. Kirjaudu sis\u00e4\u00e4n painamalla Kirjaudu-painiketta."
                }
              </div>
              <SgsButton
                data-plasmic-name={"loginBtn"}
                data-plasmic-override={overrides.loginBtn}
                className={classNames("__wab_instance", sty.loginBtn, {
                  [sty.loginBtnviewState_courses]: hasVariant(
                    $state,
                    "viewState",
                    "courses"
                  )
                })}
              />

              <div
                data-plasmic-name={"closeBtn"}
                data-plasmic-override={overrides.closeBtn}
                className={classNames(projectcss.all, sty.closeBtn)}
              >
                <Icon5Icon
                  data-plasmic-name={"svg"}
                  data-plasmic-override={overrides.svg}
                  className={classNames(projectcss.all, sty.svg)}
                  role={"img"}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "pHeader",
    "tabs",
    "courses",
    "membershipWrapper",
    "membership",
    "login",
    "admin",
    "resetPassword",
    "magicLink",
    "text",
    "loginBtn",
    "closeBtn",
    "svg"
  ],

  pHeader: ["pHeader"],
  tabs: ["tabs"],
  courses: ["courses"],
  membershipWrapper: ["membershipWrapper", "membership"],
  membership: ["membership"],
  login: ["login"],
  admin: ["admin"],
  resetPassword: ["resetPassword"],
  magicLink: ["magicLink"],
  text: ["text"],
  loginBtn: ["loginBtn"],
  closeBtn: ["closeBtn", "svg"],
  svg: ["svg"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    pHeader: makeNodeComponent("pHeader"),
    tabs: makeNodeComponent("tabs"),
    courses: makeNodeComponent("courses"),
    membershipWrapper: makeNodeComponent("membershipWrapper"),
    membership: makeNodeComponent("membership"),
    login: makeNodeComponent("login"),
    admin: makeNodeComponent("admin"),
    resetPassword: makeNodeComponent("resetPassword"),
    magicLink: makeNodeComponent("magicLink"),
    text: makeNodeComponent("text"),
    loginBtn: makeNodeComponent("loginBtn"),
    closeBtn: makeNodeComponent("closeBtn"),
    svg: makeNodeComponent("svg"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
